/**
 * UYAP ilam türü kuralları.
 *
 * Değerler UYAP Avukat Portal'ın kendi ilam türü kodlarıdır (MDB.ilamKurumTurleri).
 * Daha önce bu listeler UyapTakipAc, UyapIlamBilgileriForm ve takipHazirla store'unda
 * ayrı ayrı hardcode ediliyordu; biri güncellenip diğeri unutulduğunda sessiz hatalar
 * çıktığı için tek kaynağa taşındı.
 *
 * Kaynak: avukat.uyap.gov.tr HAR kayıtları (2026-08) ile doğrulandı.
 */
export enum UyapIlamTuru {
    HukukMahkemesi = 0,
    CezaMahkemesi = 1,
    IdareMahkemesi = 2,
    Noter = 3,
    HakemKarari = 4,
    Arabuluculuk = 5,
    Diger = 6,
    BolgeAdliyeMahkemesi = 7,
}

/**
 * UYAP `icra_takip_ilam_dosyasi_uygunmu.ajx` dosya eşleştirme sorgusunu yalnızca bu
 * türler için çağırır. Diğer türlerde UYAP ekranında "Dosya Sorgula" butonu bile yoktur.
 */
export const SORGULANABILIR_ILAM_TURLERI: number[] = [
    UyapIlamTuru.HukukMahkemesi,
    UyapIlamTuru.CezaMahkemesi,
    UyapIlamTuru.IdareMahkemesi,
];

/**
 * UYAP'ta dosya eşleştirmesi yapılamayan türler. Karşılığında dayanak belgesi zorunludur.
 * BAM (7) da buradadır: UYAP tarafında yargı birimi listesi boş döndüğü için sorgu
 * yapılamıyor, dolayısıyla hiçbir doğrulamadan geçmeden takip açılmasını engellemek gerekiyor.
 */
export const DAYANAK_ZORUNLU_ILAM_TURLERI: number[] = [
    UyapIlamTuru.Noter,
    UyapIlamTuru.HakemKarari,
    UyapIlamTuru.Arabuluculuk,
    UyapIlamTuru.Diger,
    UyapIlamTuru.BolgeAdliyeMahkemesi,
];

/**
 * Adliye seçimi olan türler. İdare Mahkemesi (2) sorgulanabilir olmasına rağmen buraya
 * dahil değildir; UYAP orada `ildekiIdaribirimleriGetir.ajx` kullanır ve Adliye alanı yoktur.
 */
export const ADLIYELI_ILAM_TURLERI: number[] = [
    UyapIlamTuru.HukukMahkemesi,
    UyapIlamTuru.CezaMahkemesi,
];

/**
 * UYAP'ta seçilebilir olmayan türler; İlam Türü listesinden gizlenir.
 * BAM daireleri zaten Hukuk (7703, 7710) ve Ceza (7702) yargı birimleri altından seçilebiliyor.
 */
export const KULLANIM_DISI_ILAM_TURLERI: number[] = [UyapIlamTuru.BolgeAdliyeMahkemesi];

/** İlam türü kodları XML'den string, MDB'den string, parser'dan number gelebiliyor. */
function toKod(ilamTuru: unknown): number {
    if (ilamTuru === null || ilamTuru === undefined || ilamTuru === '') return NaN;
    return Number(ilamTuru);
}

export function isSorgulanabilirIlamTuru(ilamTuru: unknown): boolean {
    return SORGULANABILIR_ILAM_TURLERI.includes(toKod(ilamTuru));
}

export function isDayanakZorunluIlamTuru(ilamTuru: unknown): boolean {
    return DAYANAK_ZORUNLU_ILAM_TURLERI.includes(toKod(ilamTuru));
}

export function isAdliyeliIlamTuru(ilamTuru: unknown): boolean {
    return ADLIYELI_ILAM_TURLERI.includes(toKod(ilamTuru));
}

export function isKullanimDisiIlamTuru(ilamTuru: unknown): boolean {
    return KULLANIM_DISI_ILAM_TURLERI.includes(toKod(ilamTuru));
}

/**
 * İlam türü hem `Ilam.ilamTuru` hem `Ilam.ilamBilgileri.ilamTuru` alanlarında tutuluyor ve
 * bunlar geçmişte birbirinden kopabiliyordu (Ilam.parse birimId boşken yalnızca üst seviyeyi
 * güncelliyordu). Tür okuyan her yer bu yardımcıyı kullanmalı.
 */
export function ilamTuruKodu(ilam: any): unknown {
    if (!ilam) return undefined;
    const ustSeviye = ilam.ilamTuru;
    if (ustSeviye !== null && ustSeviye !== undefined && ustSeviye !== '')
        return ustSeviye;
    return ilam.ilamBilgileri ? ilam.ilamBilgileri.ilamTuru : undefined;
}
